// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@west/App/Components/Notify";
import { miniMyProjectsStyles } from "@west/App/Widgets/MiniMyProjects/MiniMyProjects";
import { color, xScreen } from "@west/XDL/Utilities";
import { viewAllStyle } from "@west/XDL/Utilities/links";
import { css } from "styled-components";

miniMyProjectsStyles.container = {
    css: css`
        max-width: 317px;
        width: 100%;
        border: 1px solid ${color("common.border")};
        background-color: ${color("common.white")};
        padding: 16px;
        ${xScreen("lte", "sm")} {
            max-width: 100%;
        }
    `,
};

miniMyProjectsStyles.title = {
    variant: "h4",
    css: css`
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

miniMyProjectsStyles.noWishListsText = {
    ...getNotifyStyle("info", { removeMargin: true }),
};

miniMyProjectsStyles.itemsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        ${xScreen("lte", "sm")} {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 12px 20px;
        }
        ${xScreen("lt", 600)} {
            flex-direction: column;
            gap: 12px;
            flex-wrap: nowrap;
        }
    `,
};

miniMyProjectsStyles.itemContainer = {
    css: css`
        display: flex;
        gap: 12px;
        ${xScreen("lte", "sm")} {
            width: 100%;
            max-width: calc(50% - 10px);
        }
        ${xScreen("lt", 600)} {
            max-width: 100%;
        }
    `,
};

miniMyProjectsStyles.itemImageContainer = {
    css: css`
        width: 72px;
        height: 72px;
    `,
};

miniMyProjectsStyles.itemImage = {
    width: "72px",
    height: "72px",
};

miniMyProjectsStyles.itemInfoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 6px 0;
    `,
};

miniMyProjectsStyles.itemNameLink = {
    color: "text.main",
    typographyProps: {
        size: 14,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
        `,
    },
};

miniMyProjectsStyles.itemUpdatedOn = {
    size: 12,
    weight: "normal",
    css: css`
        letter-spacing: 0;
        line-height: 16px;
    `,
};

miniMyProjectsStyles.viewAllLink = {
    ...viewAllStyle,
    css: css`
        margin-top: 16px;
    `,
};
